module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/customer-creation/customer-creation.component.css
// module id = ./src/app/masters/customer-creation/customer-creation.component.css
// module chunks = main